import { Component, ContentChild, Input, TemplateRef, ChangeDetectionStrategy } from "@angular/core";
import { BridgeComponent } from "../bridge.component";
import { NgTemplateOutlet } from "@angular/common";
import { SpinnerComponent } from "../../../elements/spinner/spinner.component";

@Component({
    selector: "my-bridge-config",
    templateUrl: "config-screen.bridge.component.html",
    styleUrls: ["config-screen.bridge.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, NgTemplateOutlet]
})
export class ConfigScreenBridgeComponent {
    @Input() bridgeComponent: BridgeComponent<any>;
    @ContentChild(TemplateRef, { static: false })
    bridgeParamsTemplate: TemplateRef<any>;
}
